import React from "react";
import AdminProducts from "../../components/admin/components/AdminProducts";

const Products = () => {
  return <AdminProducts />;
};

export default Products;
